"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Entity_1 = require("./Entity");

var utils_1 = require("../utils");

var PolymathError_1 = require("../PolymathError");

var types_1 = require("../types");
/**
 * @hidden
 * Checks if a value is of type [[UniqueIdentifiers]]
 */


function isUniqueIdentifiers(identifier) {
  var address = identifier.address;
  return typeof address === 'string';
}
/**
 * Used to manage a wallet
 */


var Wallet =
/*#__PURE__*/
function (_Entity_1$Entity) {
  _inherits(Wallet, _Entity_1$Entity);

  /**
   * Create a wallet entity
   */
  function Wallet(params, context) {
    var _this;

    _classCallCheck(this, Wallet);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Wallet).call(this));
    /**
     * Retrieve the POLY balance of this particular wallet address
     */

    _this.getPolyBalance = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var address, context;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                address = this.address, context = this.context;
                return _context.abrupt("return", context.contractWrappers.polyToken.balanceOf({
                  owner: address
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Retrieve the ETH balance of this particular wallet address
     */


    _this.getEthBalance = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var address, context;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                address = this.address, context = this.context;
                return _context2.abrupt("return", context.contractWrappers.getBalance({
                  address: address
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Retrieve the ERC20 balance of this particular wallet address
     *
     * @param args.tokenAddress - address of the ERC20 token contract
     */


    _this.getErc20Balance = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var context, address, tokenAddress, erc20Wrapper;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = this.context, address = this.address;
                tokenAddress = args.tokenAddress;
                _context3.next = 4;
                return context.contractWrappers.getERC20TokenWrapper({
                  address: tokenAddress
                });

              case 4:
                erc20Wrapper = _context3.sent;
                return _context3.abrupt("return", erc20Wrapper.balanceOf({
                  owner: address
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    var address = params.address;
    _this.address = address;
    _this.context = context;
    _this.uid = Wallet.generateId({
      address: address
    });
    return _this;
  }
  /**
   * Generate the Wallet's UUID from its identifying properties
   */


  _createClass(Wallet, [{
    key: "toPojo",

    /**
     * Convert entity to a POJO (Plain Old Javascript Object)
     */
    value: function toPojo() {
      var uid = this.uid,
          address = this.address;
      return {
        uid: uid,
        address: address
      };
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh(params) {
      var address = params.address;

      if (address) {
        this.address = address;
      }
    }
  }], [{
    key: "generateId",
    value: function generateId(_ref) {
      var address = _ref.address;
      return utils_1.serialize('wallet', {
        address: address
      });
    }
    /**
     * Unserialize a serialized entity
     *
     * @param serialized - string with entity information
     */

  }, {
    key: "unserialize",
    value: function unserialize(serialized) {
      var unserialized = utils_1.unserialize(serialized);

      if (!isUniqueIdentifiers(unserialized)) {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.InvalidUuid,
          message: 'Wrong Wallet ID format.'
        });
      }

      return unserialized;
    }
  }]);

  return Wallet;
}(Entity_1.Entity);

exports.Wallet = Wallet;